import { render, staticRenderFns } from "./DeveloperAPI.vue?vue&type=template&id=112f6c10&scoped=true&"
import script from "./DeveloperAPI.vue?vue&type=script&lang=js&"
export * from "./DeveloperAPI.vue?vue&type=script&lang=js&"
import style0 from "./DeveloperAPI.vue?vue&type=style&index=0&id=112f6c10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112f6c10",
  null
  
)

export default component.exports